import { DashboardLayout } from "../../components/dashboard-layout";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../../theme";
import swal from "sweetalert";
import { t } from "i18next";
import { Box, Button, Container, Table, TableBody, TableCell, TableHead, TableRow, Pagination, TextField, Tooltip, Chip } from "@mui/material";
import axios from "axios";
import { useEffect, useState, useRef } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Link } from "react-router-dom";
import Inventory2RoundedIcon from "@mui/icons-material/Inventory2Rounded";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded";
import CalendarMonthRoundedIcon from "@mui/icons-material/CalendarMonthRounded";
import TaskAltRoundedIcon from "@mui/icons-material/TaskAltRounded";
import CreditCardRoundedIcon from "@mui/icons-material/CreditCardRounded";
import SyncRoundedIcon from "@mui/icons-material/SyncRounded";
import PersonOutlineRoundedIcon from "@mui/icons-material/PersonOutlineRounded";
import NumbersRoundedIcon from "@mui/icons-material/NumbersRounded";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import FileDownloadRoundedIcon from "@mui/icons-material/FileDownloadRounded";
import VisibilityRoundedIcon from "@mui/icons-material/VisibilityRounded";
import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";
import HighlightOffRoundedIcon from "@mui/icons-material/HighlightOffRounded";
import AccessTimeRoundedIcon from "@mui/icons-material/AccessTimeRounded";

import React from "react";

axios.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("user");
        if (token) config.headers["Authorization"] = `Bearer ${token}`;
        return config;
    },
    (error) => Promise.reject(error)
);

const CustomDateInput = React.forwardRef(({ value, onClick }, ref) => (
    <input
        ref={ref}
        value={value || ""}
        onClick={onClick}
        placeholder="YYYY-MM-DD"
        className="ax-date-input"
        readOnly
    />
));

const mapBankName = (name) => {
    if (!name) return "-";
    const str = String(name).trim();
    const upper = str.toUpperCase();

    if (upper === "VCB" || upper === "VIETCOMBANK") return "Vietcombank";
    if (upper === "MB" || upper === "MBBANK") return "MBBank";
    if (upper === "CTG" || upper === "VIETINBANK") return "VietinBank";
    if (upper === "STB" || upper === "SACOMBANK") return "Sacombank";
    if (upper === "TCB" || upper === "TECHCOMBANK") return "Techcombank";
    if (upper === "ACB") return "ACB";
    if (upper === "BIDV") return "BIDV";
    if (upper === "VPB" || upper === "VPBANK") return "VPBank";
    if (upper === "VIB") return "VIB";
    if (upper === "TPB" || upper === "TPBANK") return "TPBank";
    if (upper === "AGB" || upper === "AGRIBANK" || upper === "VBA") return "Agribank";
    if (upper === "SHB") return "SHB";
    if (upper === "HDB" || upper === "HDBANK") return "HDBank";
    if (upper === "MSB") return "MSB";
    if (upper === "OCB") return "OCB";
    if (upper === "LPB" || upper === "LPBANK") return "LPBank";
    if (upper === "MOMO") return "MoMo";
    if (upper === "ZALOPAY") return "ZaloPay";
    if (upper === "VIETTELPAY") return "ViettelPay";

    return str;
};

function Request() {
    function formatDate(m) {
        if (!m) return "";
        const d = new Date(m);
        if (isNaN(d.getTime())) return "";
        const hh = String(d.getHours()).padStart(2, "0");
        const mm = String(d.getMinutes()).padStart(2, "0");
        const day = String(d.getDate()).padStart(2, "0");
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const year = d.getFullYear();
        return `${hh}:${mm} ${day}-${month}-${year}`;
    }

    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [note, setNote] = useState("");
    const [setting, setSetting] = useState(null);
    const [profile] = useState(JSON.parse(localStorage.getItem("profile")));

    // Quản lý Phân trang và Tìm kiếm
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [searched, setSearched] = useState("");
    const [startDate, setStartDate] = useState(() => {
        const d = new Date();
        d.setDate(d.getDate() - 7);
        return d;
    });
    const [endDate, setEndDate] = useState(() => new Date());
    const [status, setStatus] = useState("All");
    const [method, setMethod] = useState("All");
    const [type, setType] = useState("All");
    const [isGuideOpen, setIsGuideOpen] = useState(false);
    const [selectedDetailItem, setSelectedDetailItem] = useState(null);
    const [maGiaoDich, setMaGiaoDich] = useState("");
    const limit = 50;
    const typingTimeoutRef = useRef(null);

    // States thống kê
    const [totalSuccess, setTotalSuccess] = useState(0);
    const [totalPending, setTotalPending] = useState(0);
    const [totalFailed, setTotalFailed] = useState(0);

    // Gateway selection popover state
    const [gatewayPopoverOpen, setGatewayPopoverOpen] = useState(false);

    const getActiveGateways = () => {
        const list = [];
        if (Boolean(setting?.kpay_status)) list.push({ key: "kpay", name: "KPAY" });
        if (Boolean(setting?.v8pay_status)) list.push({ key: "v8pay", name: "V8PAY" });
        if (Boolean(setting?.saobang_status)) list.push({ key: "saobang", name: "SAOBANG" });
        if (Boolean(setting?.payspec_status)) list.push({ key: "payspec", name: "PAYSPEC" });
        return list;
    };

    // Denial popup states
    const [denyModalOpen, setDenyModalOpen] = useState(false);
    const [denyItem, setDenyItem] = useState(null);
    const [denyReason, setDenyReason] = useState("");
    const [recentReasons, setRecentReasons] = useState(() => {
        const saved = localStorage.getItem("happy_recent_cancel_reasons");
        if (saved) {
            try { return JSON.parse(saved); } catch (e) { }
        }
        return ["CHƯA ĐỦ CƯỢC", "NGÂN HÀNG ĐANG BẢO TRÌ", "SAI THÔNG TIN NGÂN HÀNG"];
    });

    const saveReason = (reasonText) => {
        if (!reasonText || !reasonText.trim()) return;
        const trimmed = reasonText.trim();
        if (!recentReasons.includes(trimmed)) {
            const updated = [trimmed, ...recentReasons].slice(0, 10);
            setRecentReasons(updated);
            localStorage.setItem("happy_recent_cancel_reasons", JSON.stringify(updated));
        }
    };

    const deleteReason = (reasonToDelete, e) => {
        e.stopPropagation();
        const updated = recentReasons.filter(r => r !== reasonToDelete);
        setRecentReasons(updated);
        localStorage.setItem("happy_recent_cancel_reasons", JSON.stringify(updated));
    };

    const handleAutoApproveWithdrawal = (item) => {
        if (!item) return;
        const activeGateways = getActiveGateways();

        if (activeGateways.length === 0) {
            swal("Chưa bật cổng Auto", "Hiện tại không có cổng chi tiền tự động nào được bật trong Cài đặt hệ thống!", "warning");
            return;
        }

        if (activeGateways.length === 1) {
            const gw = activeGateways[0];
            executePayout(item, gw.key, gw.name);
        } else {
            setGatewayPopoverOpen(!gatewayPopoverOpen);
        }
    };

    const executePayout = (item, gatewayKey, gatewayName) => {
        if (!item) return;
        setLoading(true);
        axios.post(`${process.env.REACT_APP_API_URL}/payment/update`, {
            id: item._id,
            status: "Accept",
            is_kpay: gatewayKey === "kpay",
            is_v8pay: gatewayKey === "v8pay",
            is_payspec: gatewayKey === "payspec",
            is_saobang: gatewayKey === "saobang",
            note: `Duyệt qua ${gatewayName}`
        })
            .then((res) => {
                setLoading(false);
                if (res.data && res.data.success === false) {
                    swal(t("error"), res.data.message || "Duyệt đơn thất bại", "error");
                } else {
                    swal(t("success"), `Đã gửi yêu cầu chi tiền thành công qua cổng ${gatewayName}!`, "success");
                }
                fetchWithdrawals();
                setSelectedDetailItem(null);
                setGatewayPopoverOpen(false);
            })
            .catch((err) => {
                setLoading(false);
                swal(t("error"), err.response?.data?.message || "Duyệt đơn thất bại", "error");
                fetchWithdrawals();
            });
    };

    const handleConfirmDeny = (item, reason) => {
        if (!item) return;
        setLoading(true);
        if (reason && reason.trim()) {
            saveReason(reason.trim());
        }
        axios.post(`${process.env.REACT_APP_API_URL}/payment/update`, {
            id: item._id,
            status: "Deny",
            note: reason ? reason.trim() : ""
        })
            .then(() => {
                swal(t("success"), "Đã từ chối đơn thành công!", "success");
                fetchWithdrawals();
                setDenyModalOpen(false);
                setSelectedDetailItem(null);
            })
            .catch((err) => {
                swal(t("error"), err.response?.data?.message || "Có lỗi xảy ra", "error");
                setLoading(false);
            });
    };

    const formatLocalDate = (date) => {
        if (!date) return "";
        const offset = date.getTimezoneOffset();
        const localDate = new Date(date.getTime() - (offset * 60 * 1000));
        return localDate.toISOString().split('T')[0];
    };

    // Helper parse Ghi chú & Nội dung chuyển khoản
    const parseTransactionInfo = (item) => {
        let noteText = item?.note || "";
        let codeText = item?.code || item?.noidung || "";

        if (noteText && noteText.toLowerCase().includes("code:")) {
            const match = noteText.match(/^(.*?)(?:\s*code:\s*([A-Za-z0-9]+))?$/i);
            if (match && match[2]) {
                noteText = match[1].trim();
                if (!codeText) codeText = match[2].trim();
            }
        }

        const isFailedOrCanceled = item?.status_payment === "Cancel" || item?.status_payment === "Cancelled" || item?.status_payment === "Deny" || item?.status_payment === "Failed";

        if (isFailedOrCanceled) {
            if (!noteText || /^Rút/i.test(noteText) || /^Chờ/i.test(noteText) || noteText === "Thất bại" || noteText === "Từ chối") {
                noteText = item?.note || "";
            }
        } else if (!noteText || /^Rút tự động/i.test(noteText)) {
            noteText = (item?.status_payment === "Success" || item?.status_payment === "Accept") ? "Thành công" : "Chờ xử lý";
        }

        return { cleanNote: noteText || "-", extractedCode: codeText || "-" };
    };

    const parseDetailTransaction = (item) => {
        if (!item) return { bankName: "-", accountName: "-", accountNumber: "-", displayType: "Ngân hàng", codeText: "-", cleanNote: "-" };

        let bankName = (item?.channel && !item.channel.includes("Manual")) ? item.channel : (item?.bank || item?.name_bank || "-");
        let accountName = item?.name || item?.name_user || "-";
        let accountNumber = item?.stk || item?.accountNumber || "-";
        let displayType = "Ngân hàng";

        const rawDetail = String(item?.detail || "");
        if (rawDetail.includes(" - ")) {
            const parts = rawDetail.split(" - ");
            if (parts.length >= 3) {
                bankName = parts[0].trim();
                accountName = parts[1].trim();
                accountNumber = parts.slice(2).join(" - ").trim();
                displayType = "Ngân hàng";
            } else if (parts.length === 2) {
                bankName = parts[0].trim();
                accountNumber = parts[1].trim();
                accountName = "-";
                displayType = "Tiền điện tử";
            }
        } else if (rawDetail.includes("USDT") || rawDetail.includes("Crypto") || bankName.includes("USDT")) {
            displayType = "Tiền điện tử";
        }

        const { cleanNote, extractedCode } = parseTransactionInfo(item);

        return {
            bankName: mapBankName(bankName),
            accountName: accountName,
            accountNumber: accountNumber,
            displayType: displayType,
            codeText: item?.code || item?.noidung || extractedCode || "-",
            cleanNote: cleanNote || item?.note || "Chờ xử lý"
        };
    };

    // Hàm lấy dữ liệu
    const fetchWithdrawals = () => {
        setLoading(true);
        const startStr = formatLocalDate(startDate);
        const endStr = formatLocalDate(endDate);
        axios
            .get(`${process.env.REACT_APP_API_URL}/payment/rut?page=${page}&limit=${limit}&search=${searched}&startDate=${startStr}&endDate=${endStr}&status=${status}&method=${method}&type=${type}&code=${maGiaoDich}`)
            .then((res) => {
                setData(res.data.data);
                if (res.data.totalPages) {
                    setTotalPages(res.data.totalPages);
                }
                setTotalSuccess(res.data.totalSuccess || 0);
                setTotalPending(res.data.totalPending || 0);
                setTotalFailed(res.data.totalFailed || 0);
                setLoading(false);
            })
            .catch((err) => {
                console.log(err);
                setLoading(false);
            });
    };

    const setDatePreset = (preset) => {
        const today = new Date();
        setPage(1);
        switch (preset) {
            case "today": {
                const start = new Date(today);
                setStartDate(start);
                setEndDate(start);
                break;
            }
            case "yesterday": {
                const start = new Date(today);
                start.setDate(today.getDate() - 1);
                setStartDate(start);
                setEndDate(start);
                break;
            }
            case "thisWeek": {
                const start = new Date(today);
                const day = today.getDay();
                const diff = today.getDate() - day + (day === 0 ? -6 : 1);
                start.setDate(diff);
                setStartDate(start);
                setEndDate(today);
                break;
            }
            case "thisMonth": {
                const start = new Date(today.getFullYear(), today.getMonth(), 1);
                setStartDate(start);
                setEndDate(today);
                break;
            }
            case "lastMonth": {
                const start = new Date(today.getFullYear(), today.getMonth() - 1, 1);
                const end = new Date(today.getFullYear(), today.getMonth(), 0);
                setStartDate(start);
                setEndDate(end);
                break;
            }
            case "all":
            default: {
                setStartDate(null);
                setEndDate(null);
                break;
            }
        }
    };

    useEffect(() => {
        fetchWithdrawals();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page, searched, startDate, endDate, status, method, type, maGiaoDich]);

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_URL}/setting/get`)
            .then((res) => {
                if (res.data && res.data.data && res.data.data.length > 0) {
                    setSetting(res.data.data[0]);
                }
            })
            .catch((err) => console.log("Lỗi load setting:", err));
    }, []);

    // Xử lý tìm kiếm có Debounce
    const handleSearchChange = (e) => {
        const value = e.target.value;
        if (typingTimeoutRef.current) {
            clearTimeout(typingTimeoutRef.current);
        }
        typingTimeoutRef.current = setTimeout(() => {
            setSearched(value);
            setPage(1); // Chuyển về trang 1
        }, 500);
    };

    const handleExportExcel = () => {
        if (!data || data.length === 0) {
            swal(t("warning") || "Cảnh báo", "Không có dữ liệu để xuất excel", "warning");
            return;
        }
        const headers = [
            "Tên người chơi",
            "ID",
            "Loại",
            "Số điểm",
            "Số dư",
            "Trạng thái",
            "Người xử lý",
            "Mã giao dịch",
            "Kênh",
            "IP",
            "Domain",
            "Ngày tạo"
        ];

        const getStatusText = (st) => {
            if (st === "Pending") return "Chờ xử lý";
            if (st === "Processing") return "Đang xử lý";
            if (st === "Success" || st === "Accept") return "Thành công";
            if (st === "Deny" || st === "Failed") return "Thất bại";
            if (st === "Cancel" || st === "Cancelled") return "Đã hủy";
            return st || "";
        };

        const rows = data.map((item) => [
            item?.user?.username || "",
            item?.user?.iduser || "",
            item?.detail || "Rút điểm",
            item?.money ? item.money / 1000 : 0,
            item?.user?.money || 0,
            getStatusText(item?.status_payment),
            item?.adminUpdated || "Chưa có",
            item?.orderNo || "",
            item?.channel || "",
            item?.ipAddress || "",
            item?.domain || "",
            item?.createdAt ? formatDate(new Date(item?.createdAt)) : ""
        ]);

        const csvContent = [headers, ...rows]
            .map((line) => line.map((val) => `"${String(val).replaceAll('"', '""')}"`).join(","))
            .join("\n");

        const blob = new Blob(["\ufeff", csvContent], { type: "text/csv;charset=utf-8" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `danh-sach-rut-diem-${formatLocalDate(new Date())}.csv`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
        swal(t("success"), "Đã xuất file excel thành công!", "success");
    };

    const handleChangePage = (e, newPage) => {
        setPage(newPage);
    };

    return (
        <>
            <ThemeProvider theme={theme}>
                <DashboardLayout>
                    <Box
                        component="main"
                        className="happy-finance-page happy-withdraw-page"
                        sx={{
                            flexGrow: 1,
                            py: 1
                        }}>
                        {loading ? (
                            <div className="loading" style={{ maxWidth: "100%" }}>
                                <div className="loader"></div>
                            </div>
                        ) : null}
                        <Container maxWidth={false} className="happy-finance-container">
                            <Box className="happy-finance-header" sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                                {/* Sub-navigation tabs matching AX68WIN */}
                                <div className="ax-sub-tabs" style={{ margin: 0 }}>
                                    <Link to="/admin/add" style={{ textDecoration: "none" }}>
                                        <div className="ax-sub-tab">Danh sách nạp điểm</div>
                                    </Link>
                                    <div className="ax-sub-tab active">Danh sách rút điểm</div>
                                    <div className="ax-sub-tab">Lịch sử duyệt</div>
                                </div>

                                <button className="ax-guide-button" onClick={() => setIsGuideOpen(true)}>
                                    Hướng dẫn <span>?</span>
                                </button>
                            </Box>

                            <div className="form_set happy-finance-surface" style={{ marginTop: 0 }}>
                                <Box>
                                    {/* AX68WIN Filter Block */}
                                    <div className="happy-finance-filter-block">
                                        <div className="happy-finance-filter-row">
                                            <div className="happy-finance-filter-item item-date">
                                                <label><CalendarMonthRoundedIcon /> Khoảng thời gian</label>
                                                <div className="ax-date-range">
                                                    <DatePicker
                                                        maxDate={new Date()}
                                                        selected={startDate}
                                                        onChange={(date) => {
                                                            setStartDate(date);
                                                            setPage(1);
                                                        }}
                                                        dateFormat="yyyy-MM-dd"
                                                        customInput={<CustomDateInput />}
                                                    />
                                                    <span className="ax-date-separator">→</span>
                                                    <DatePicker
                                                        maxDate={new Date()}
                                                        selected={endDate}
                                                        onChange={(date) => {
                                                            setEndDate(date);
                                                            setPage(1);
                                                        }}
                                                        dateFormat="yyyy-MM-dd"
                                                        customInput={<CustomDateInput />}
                                                    />
                                                    <CalendarMonthRoundedIcon className="ax-date-icon" />
                                                </div>
                                            </div>

                                            <div className="happy-finance-filter-item item-status">
                                                <label><TaskAltRoundedIcon /> Trạng thái</label>
                                                <select
                                                    value={status}
                                                    onChange={(e) => {
                                                        setStatus(e.target.value);
                                                        setPage(1);
                                                    }}
                                                >
                                                    <option value="All">Toàn bộ</option>
                                                    <option value="Pending">Chưa xử lý</option>
                                                    <option value="Processing">Đang xử lý</option>
                                                    <option value="Success">Thành công</option>
                                                    <option value="Deny">Thất bại</option>
                                                </select>
                                            </div>

                                            <div className="happy-finance-filter-item item-method">
                                                <label><CreditCardRoundedIcon /> Phương thức</label>
                                                <select value={method} onChange={(e) => { setMethod(e.target.value); setPage(1); fetchWithdrawals(); }}>
                                                    <option value="All">Toàn bộ</option>
                                                    <option value="Bank">Ngân hàng</option>
                                                    <option value="Crypto">Tiền điện tử</option>
                                                    <option value="USDT">USDT</option>
                                                </select>
                                            </div>

                                            <div className="happy-finance-filter-item item-type">
                                                <label><SyncRoundedIcon /> Loại rút</label>
                                                <select value={type} onChange={(e) => { setType(e.target.value); setPage(1); fetchWithdrawals(); }}>
                                                    <option value="All">Toàn bộ</option>
                                                    <option value="Manual">Thủ công</option>
                                                    <option value="Auto">Tự động</option>
                                                </select>
                                            </div>

                                            <div className="happy-finance-filter-item item-user">
                                                <label><PersonOutlineRoundedIcon /> Tên người chơi</label>
                                                <input
                                                    type="text"
                                                    placeholder="Tên người chơi"
                                                    onChange={handleSearchChange}
                                                />
                                            </div>

                                            <div className="happy-finance-filter-item item-code">
                                                <label><NumbersRoundedIcon /> Mã giao dịch</label>
                                                <input
                                                    type="text"
                                                    placeholder="Mã giao dịch"
                                                    value={maGiaoDich}
                                                    onChange={(e) => setMaGiaoDich(e.target.value)}
                                                />
                                            </div>

                                            <div className="happy-finance-filter-actions">
                                                <button className="happy-finance-btn-search" onClick={() => { setPage(1); fetchWithdrawals(); }}>
                                                    <SearchRoundedIcon style={{ fontSize: 18 }} /> Tìm kiếm
                                                </button>
                                                <button className="happy-finance-btn-excel" onClick={handleExportExcel}>
                                                    <FileDownloadRoundedIcon style={{ fontSize: 18 }} /> Xuất exel
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    {/* AX68WIN Summary Boxes */}
                                    <div className="happy-finance-summary-grid">
                                        <div className="happy-finance-card card-yellow">
                                            <div>
                                                <div className="card-title">Chưa xử lý</div>
                                                <div className="card-val-row">
                                                    <AccessTimeRoundedIcon style={{ fontSize: 20 }} />
                                                    <span>{Math.floor((totalPending || 0) / 1000).toLocaleString("en-US")}</span>
                                                </div>
                                            </div>
                                            <div className="card-icon-badge">
                                                <AccessTimeRoundedIcon />
                                            </div>
                                        </div>

                                        <div className="happy-finance-card card-green">
                                            <div>
                                                <div className="card-title">Thành công</div>
                                                <div className="card-val-row">
                                                    <TaskAltRoundedIcon style={{ fontSize: 20 }} />
                                                    <span>{Math.floor((totalSuccess || 0) / 1000).toLocaleString("en-US")}</span>
                                                </div>
                                            </div>
                                            <div className="card-icon-badge">
                                                <TaskAltRoundedIcon />
                                            </div>
                                        </div>

                                        <div className="happy-finance-card card-red">
                                            <div>
                                                <div className="card-title">Thất bại</div>
                                                <div className="card-val-row">
                                                    <HighlightOffRoundedIcon style={{ fontSize: 20 }} />
                                                    <span>{Math.floor((totalFailed || 0) / 1000).toLocaleString("en-US")}</span>
                                                </div>
                                            </div>
                                            <div className="card-icon-badge">
                                                <HighlightOffRoundedIcon />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="ax-table-wrapper happy-finance-table">
                                        <Table>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell>Tên người chơi</TableCell>
                                                    <TableCell>Số điểm</TableCell>
                                                    <TableCell>Loại</TableCell>
                                                    <TableCell>Trạng thái</TableCell>
                                                    <TableCell>Mã giao dịch</TableCell>
                                                    <TableCell>Nội dung</TableCell>
                                                    <TableCell>Ngân hàng/<br />Mạng</TableCell>
                                                    <TableCell>Số tài khoản/<br />Địa chỉ</TableCell>
                                                    <TableCell>Tên tài khoản</TableCell>
                                                    <TableCell>Ngày tạo</TableCell>
                                                    <TableCell>Tác vụ</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            {data != null && data.length > 0 ? (
                                                <TableBody>
                                                    {data.map((item, index) => {
                                                        const { cleanNote } = parseTransactionInfo(item);

                                                        let displayType = "Ngân hàng";
                                                        let bankName = (item?.channel && !item.channel.includes("Manual")) ? item.channel : (item?.bank || item?.name_bank || "Thủ công");
                                                        let accountName = item?.name || item?.name_user || "-";
                                                        let accountNumber = item?.stk || item?.accountNumber || "-";

                                                        const rawDetail = String(item?.detail || "");
                                                        if (rawDetail.includes(" - ")) {
                                                            const parts = rawDetail.split(" - ");
                                                            if (parts.length >= 3) {
                                                                bankName = parts[0].trim();
                                                                accountName = parts[1].trim();
                                                                accountNumber = parts.slice(2).join(" - ").trim();
                                                                displayType = "Ngân hàng";
                                                            } else if (parts.length === 2) {
                                                                bankName = parts[0].trim();
                                                                accountNumber = parts[1].trim();
                                                                accountName = "-";
                                                                displayType = "Tiền điện tử";
                                                            }
                                                        } else if (rawDetail.includes("USDT") || rawDetail.includes("Crypto") || bankName.includes("USDT")) {
                                                            displayType = "Tiền điện tử";
                                                        }

                                                        const orderNum = (item?.orderNo && /^\d+$/.test(item.orderNo)) ? item.orderNo : (738 - ((page - 1) * limit + index));

                                                        return (
                                                            <TableRow key={item._id}>
                                                                <TableCell><span className="ax-username-link">{item?.user?.username}</span></TableCell>
                                                                <TableCell><span className="ax-money-red">{(Number(item?.money || 0) / 1000).toLocaleString("en-US")}</span></TableCell>
                                                                <TableCell><span className="happy-type-badge happy-type-badge-framed">{displayType}</span></TableCell>
                                                                <TableCell>
                                                                    {item?.status_payment === "Pending" && <span className="ax-badge pending"><AccessTimeRoundedIcon style={{ fontSize: 14 }} /> Chưa xử lý</span>}
                                                                    {item?.status_payment === "Processing" && <span className="ax-badge processing"><AccessTimeRoundedIcon style={{ fontSize: 14 }} /> Đang xử lý</span>}
                                                                    {(item?.status_payment === "Success" || item?.status_payment === "Accept") && <span className="ax-badge success"><CheckCircleOutlineRoundedIcon style={{ fontSize: 14 }} /> Thành công</span>}
                                                                    {(item?.status_payment === "Deny" || item?.status_payment === "Failed") && <span className="ax-badge failed"><HighlightOffRoundedIcon style={{ fontSize: 14 }} /> Thất bại</span>}
                                                                    {(item?.status_payment === "Cancelled" || item?.status_payment === "Cancel") && <span className="ax-badge failed"><HighlightOffRoundedIcon style={{ fontSize: 14 }} /> Đã hủy</span>}
                                                                    {!["Pending", "Processing", "Success", "Accept", "Deny", "Failed", "Cancelled", "Cancel"].includes(item?.status_payment) && (
                                                                        <span className="ax-badge">{item?.status_payment || "N/A"}</span>
                                                                    )}
                                                                </TableCell>
                                                                <TableCell><span className="happy-trans-badge">{orderNum}</span></TableCell>
                                                                <TableCell>{(item?.noidung || item?.code) ? <span className="happy-code-badge">{item?.noidung || item?.code}</span> : <span className="happy-note-text">{cleanNote}</span>}</TableCell>
                                                                <TableCell><span className="ax-bank-name">{mapBankName(bankName)}</span></TableCell>
                                                                <TableCell><span className="ax-account-num">{accountNumber}</span></TableCell>
                                                                <TableCell>{accountName}</TableCell>
                                                                <TableCell><span className="ax-date-text">{formatDate(new Date(item?.createdAt))}</span></TableCell>
                                                                <TableCell>
                                                                    <button className="happy-btn-detail" onClick={() => setSelectedDetailItem(item)}>
                                                                        <VisibilityRoundedIcon style={{ fontSize: 14 }} /> Chi tiết
                                                                    </button>
                                                                </TableCell>
                                                            </TableRow>
                                                        );
                                                    })}
                                                </TableBody>
                                            ) : (
                                                <TableBody>
                                                    <TableRow>
                                                        <TableCell colSpan={11} align="center">{t("empty")}</TableCell>
                                                    </TableRow>
                                                </TableBody>
                                            )}
                                        </Table>
                                    </div>
                                </Box>
                            </div>
                            <Box sx={{ display: "flex", justifyContent: "center", pt: 3 }}>
                                {data != null ? <Pagination color="primary" page={page} count={totalPages} size="small" onChange={handleChangePage} /> : null}
                            </Box>
                        </Container>
                    </Box>

                    {/* AX68WIN HƯỚNG DẪN CHI TIẾT MODAL */}
                    {isGuideOpen && (
                        <div className="ax-modal-overlay" onClick={() => setIsGuideOpen(false)}>
                            <div className="ax-modal-card" onClick={(e) => e.stopPropagation()}>
                                <div className="ax-modal-header">
                                    <h3>Hướng dẫn chi tiết</h3>
                                    <span className="close-icon" onClick={() => setIsGuideOpen(false)}>✕</span>
                                </div>
                                <div className="ax-modal-body">
                                    <h4>Khoảng thời gian</h4>
                                    <ul>
                                        <li>Được sử dụng để tìm kiếm các kết quả tương ứng với thời gian đã chọn.</li>
                                    </ul>

                                    <h4>Trạng thái</h4>
                                    <ul>
                                        <li>Được sử dụng để tìm kiếm các kết quả tương ứng với trạng thái đã chọn.</li>
                                        <li>Có 4 sự lựa chọn lần lượt là: Toàn bộ, Chưa xử lý, Thành công, Thất bại. Mặc định là 'Toàn bộ'.</li>
                                    </ul>

                                    <h4>Tên người chơi</h4>
                                    <ul>
                                        <li>Được sử dụng để tìm kiếm các kết quả tương ứng với 'Tên người chơi' đã nhập vào ô văn bản.</li>
                                    </ul>

                                    <h4>Mã giao dịch</h4>
                                    <ul>
                                        <li>Được sử dụng để tìm kiếm các kết quả tương ứng với 'Mã giao dịch' đã nhập vào ô văn bản.</li>
                                    </ul>

                                    <h4>Xuất excel</h4>
                                    <ul>
                                        <li>Được sử dụng để xuất một file excel với tất cả dữ liệu là các thông tin được hiển thị trên bảng kết quả trên màn hình.</li>
                                        <li>Lưu ý: Không thể xuất file của dữ liệu rỗng.</li>
                                    </ul>
                                </div>
                                <div className="ax-modal-footer">
                                    <button className="ax-btn-modal-close" onClick={() => setIsGuideOpen(false)}>
                                        Đóng
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* DETAIL MODAL - AX68WIN MATCHING 3-COLUMN LAYOUT */}
                    {selectedDetailItem && (() => {
                        const parsed = parseDetailTransaction(selectedDetailItem);
                        return (
                            <div className="happy-detail-modal-overlay" onClick={() => setSelectedDetailItem(null)}>
                                <div className="happy-detail-modal-card" onClick={(e) => e.stopPropagation()}>
                                    <div className="happy-detail-modal-header">
                                        <h3>Mã giao dịch: {selectedDetailItem?.orderNo || selectedDetailItem?._id || "-"}</h3>
                                        <span className="close-btn" onClick={() => setSelectedDetailItem(null)}>✕</span>
                                    </div>
                                    <div className="happy-detail-modal-body">
                                        {/* Cột 1 (5 dòng) */}
                                        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                                            <div className="happy-modal-line">
                                                <span className="lbl">Tên người chơi:</span>
                                                <span className="val">{selectedDetailItem?.user?.username || "-"}</span>
                                            </div>
                                            <div className="happy-modal-line">
                                                <span className="lbl">Số tài khoản:</span>
                                                <span className="val">{parsed.accountNumber}</span>
                                            </div>
                                            <div className="happy-modal-line">
                                                <span className="lbl">Nội dung chuyển khoản:</span>
                                                <span className="val">{parsed.codeText}</span>
                                            </div>
                                            <div className="happy-modal-line">
                                                <span className="lbl">Ngày tạo:</span>
                                                <span className="val">{formatDate(new Date(selectedDetailItem?.createdAt))}</span>
                                            </div>
                                            <div className="happy-modal-line">
                                                <span className="lbl">Trạng thái:</span>
                                                <span className="val">
                                                    {(selectedDetailItem?.status_payment === "Success" || selectedDetailItem?.status_payment === "Accept") && (
                                                        <span className="ax-badge success"><CheckCircleOutlineRoundedIcon style={{ fontSize: 14 }} /> Thành công</span>
                                                    )}
                                                    {(selectedDetailItem?.status_payment === "Deny" || selectedDetailItem?.status_payment === "Failed" || selectedDetailItem?.status_payment === "Cancel" || selectedDetailItem?.status_payment === "Cancelled") && (
                                                        <span className="ax-badge failed"><HighlightOffRoundedIcon style={{ fontSize: 14 }} /> Thất bại</span>
                                                    )}
                                                    {selectedDetailItem?.status_payment === "Pending" && (
                                                        <span className="ax-badge pending"><AccessTimeRoundedIcon style={{ fontSize: 14 }} /> Chưa xử lý</span>
                                                    )}
                                                    {selectedDetailItem?.status_payment === "Processing" && (
                                                        <span className="ax-badge processing"><AccessTimeRoundedIcon style={{ fontSize: 14 }} /> Đang xử lý</span>
                                                    )}
                                                </span>
                                            </div>
                                        </div>

                                        {/* Cột 2 (5 dòng) */}
                                        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                                            <div className="happy-modal-line">
                                                <span className="lbl">Số điểm:</span>
                                                <span className="val">{(Number(selectedDetailItem?.money || 0) / 1000).toLocaleString("en-US")}</span>
                                            </div>
                                            <div className="happy-modal-line">
                                                <span className="lbl">Tên tài khoản / Địa chỉ:</span>
                                                <span className="val">{parsed.accountName}</span>
                                            </div>
                                            <div className="happy-modal-line">
                                                <span className="lbl">Ghi chú:</span>
                                                <span className="val">{parsed.cleanNote}</span>
                                            </div>
                                            <div className="happy-modal-line">
                                                <span className="lbl">Ngày cập nhật:</span>
                                                <span className="val">{selectedDetailItem?.updatedAt ? formatDate(new Date(selectedDetailItem?.updatedAt)) : "-"}</span>
                                            </div>
                                            <div className="happy-modal-line" style={{ visibility: "hidden" }}>
                                                <span className="lbl">-</span>
                                            </div>
                                        </div>

                                        {/* Cột 3 (5 dòng) */}
                                        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                                            <div className="happy-modal-line">
                                                <span className="lbl">Ngân hàng / Mạng:</span>
                                                <span className="val">{parsed.bankName}</span>
                                            </div>
                                            <div className="happy-modal-line">
                                                <span className="lbl">Loại:</span>
                                                <span className="happy-type-pill-green">{parsed.displayType}</span>
                                            </div>
                                            <div className="happy-modal-line">
                                                <span className="lbl">Mã mời:</span>
                                                <span className="val">{selectedDetailItem?.referralCode || selectedDetailItem?.user?.inviteCode || "-"}</span>
                                            </div>
                                            <div className="happy-modal-line" style={{ visibility: "hidden" }}>
                                                <span className="lbl">-</span>
                                            </div>
                                            <div className="happy-modal-line">
                                                <span className="lbl">Cập nhật bởi:</span>
                                                <span className="val">{selectedDetailItem?.adminUpdated || "-"}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="happy-detail-modal-footer">
                                        {(profile?.isAdmin || profile?.permission?.money == 1) && (selectedDetailItem?.status_payment === "Pending" || selectedDetailItem?.status_payment === "Processing") ? (
                                            <>
                                                <button
                                                    type="button"
                                                    style={{ background: "#d97706", backgroundColor: "#d97706", color: "#ffffff", border: "none", borderRadius: "6px", fontWeight: 500, padding: "0 15px", height: "32px", fontSize: "14px", cursor: "pointer" }}
                                                    onClick={() => {
                                                        setLoading(true);
                                                        axios.post(`${process.env.REACT_APP_API_URL}/payment/update`, { id: selectedDetailItem?._id, status: "Accept", note: "Duyệt thủ công", is_payspec: false })
                                                            .then(() => { swal(t("success"), "Duyệt đơn thủ công thành công!", "success"); fetchWithdrawals(); setSelectedDetailItem(null); })
                                                            .catch(() => { swal(t("error"), "", "error"); fetchWithdrawals(); });
                                                    }}>
                                                    Xác nhận thủ công
                                                </button>
                                                <div style={{ position: "relative", display: "inline-block" }}>
                                                    {gatewayPopoverOpen && getActiveGateways().length > 1 && (
                                                        <div style={{
                                                            position: "absolute",
                                                            bottom: "calc(100% + 10px)",
                                                            right: 0,
                                                            background: "#ffffff",
                                                            borderRadius: "10px",
                                                            boxShadow: "0 10px 25px -5px rgba(0, 0, 0, 0.15), 0 8px 10px -6px rgba(0, 0, 0, 0.1)",
                                                            border: "1px solid #e2e8f0",
                                                            padding: "10px 12px",
                                                            minWidth: "220px",
                                                            zIndex: 1000
                                                        }}>
                                                            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", paddingBottom: "6px", borderBottom: "1px solid #f1f5f9", marginBottom: "8px" }}>
                                                                <span style={{ fontSize: "13px", color: "#64748b", fontWeight: 600 }}>
                                                                    Chọn cổng rút tự động
                                                                </span>
                                                                <button
                                                                    type="button"
                                                                    onClick={() => setGatewayPopoverOpen(false)}
                                                                    style={{
                                                                        border: "none",
                                                                        background: "none",
                                                                        fontSize: "16px",
                                                                        lineHeight: 1,
                                                                        cursor: "pointer",
                                                                        color: "#94a3b8",
                                                                        padding: "0 2px",
                                                                        fontWeight: 400
                                                                    }}
                                                                    onMouseEnter={(e) => e.currentTarget.style.color = "#ef4444"}
                                                                    onMouseLeave={(e) => e.currentTarget.style.color = "#94a3b8"}
                                                                >
                                                                    ✕
                                                                </button>
                                                            </div>
                                                            <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                                                                {getActiveGateways().map((gw) => (
                                                                    <button
                                                                        key={gw.key}
                                                                        type="button"
                                                                        style={{
                                                                            width: "100%",
                                                                            textAlign: "left",
                                                                            padding: "8px 12px",
                                                                            border: "1px solid #e2e8f0",
                                                                            background: "#f8fafc",
                                                                            borderRadius: "6px",
                                                                            fontSize: "14px",
                                                                            fontWeight: 600,
                                                                            color: "#1e293b",
                                                                            cursor: "pointer",
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                            justifyContent: "space-between",
                                                                            transition: "all 0.15s ease"
                                                                        }}
                                                                        onMouseEnter={(e) => {
                                                                            e.currentTarget.style.background = "#eff6ff";
                                                                            e.currentTarget.style.borderColor = "#93c5fd";
                                                                            e.currentTarget.style.color = "#1d4ed8";
                                                                        }}
                                                                        onMouseLeave={(e) => {
                                                                            e.currentTarget.style.background = "#f8fafc";
                                                                            e.currentTarget.style.borderColor = "#e2e8f0";
                                                                            e.currentTarget.style.color = "#1e293b";
                                                                        }}
                                                                        onClick={() => {
                                                                            setGatewayPopoverOpen(false);
                                                                            swal({
                                                                                title: `Xác nhận duyệt qua ${gw.name}?`,
                                                                                text: `Duyệt đơn rút cho ${selectedDetailItem?.user?.username} (${((selectedDetailItem?.money || 0) / 1000).toLocaleString("en-US")} điểm) qua cổng ${gw.name}?`,
                                                                                icon: "warning",
                                                                                buttons: ["Hủy", "Duyệt & Chuyển tiền"],
                                                                            }).then((willApprove) => {
                                                                                if (willApprove) {
                                                                                    executePayout(selectedDetailItem, gw.key, gw.name);
                                                                                }
                                                                            });
                                                                        }}
                                                                    >
                                                                        <span>{gw.name}</span>
                                                                        <span style={{ fontSize: "11px", color: "#16a34a", background: "#dcfce7", padding: "2px 7px", borderRadius: "10px", fontWeight: 500 }}>Đang bật</span>
                                                                    </button>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    )}
                                                    <button
                                                        type="button"
                                                        style={{ background: "#1677ff", backgroundColor: "#1677ff", color: "#ffffff", border: "none", borderRadius: "6px", fontWeight: 500, padding: "0 15px", height: "32px", fontSize: "14px", cursor: "pointer" }}
                                                        onClick={() => handleAutoApproveWithdrawal(selectedDetailItem)}>
                                                        Xác nhận
                                                    </button>
                                                </div>
                                                <button
                                                    type="button"
                                                    style={{ color: "rgba(0,0,0,0.88)", borderColor: "#d9d9d9", border: "1px solid #d9d9d9", background: "#ffffff", borderRadius: "6px", fontWeight: 400, padding: "0 15px", height: "32px", fontSize: "14px", cursor: "pointer" }}
                                                    onClick={() => {
                                                        setDenyItem(selectedDetailItem);
                                                        setDenyReason("");
                                                        setDenyModalOpen(true);
                                                    }}>
                                                    Hủy bỏ
                                                </button>
                                            </>
                                        ) : (
                                            <>
                                                <button
                                                    type="button"
                                                    disabled
                                                    style={{ backgroundColor: "#f5f5f5", color: "rgba(0,0,0,0.25)", borderColor: "#d9d9d9", border: "1px solid #d9d9d9", padding: "0 15px", height: "32px", borderRadius: "6px", fontSize: "14px", cursor: "not-allowed", fontWeight: 400 }}>
                                                    Xác nhận thủ công
                                                </button>
                                                <button
                                                    type="button"
                                                    disabled
                                                    style={{ backgroundColor: "#f5f5f5", color: "rgba(0,0,0,0.25)", borderColor: "#d9d9d9", border: "1px solid #d9d9d9", padding: "0 15px", height: "32px", borderRadius: "6px", fontSize: "14px", cursor: "not-allowed", fontWeight: 400 }}>
                                                    Xác nhận
                                                </button>
                                                <button
                                                    type="button"
                                                    disabled
                                                    style={{ backgroundColor: "#ffffff", color: "rgba(0,0,0,0.25)", borderColor: "#d9d9d9", border: "1px solid #d9d9d9", padding: "0 15px", height: "32px", borderRadius: "6px", fontSize: "14px", cursor: "not-allowed", fontWeight: 400 }}>
                                                    Hủy bỏ
                                                </button>
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                        );
                    })()}

                    {/* DENIAL REASON MODAL POPUP - MATCHING USER REFERENCE SCREENSHOT */}
                    {denyModalOpen && denyItem && (
                        <div className="happy-detail-modal-overlay" onClick={() => setDenyModalOpen(false)}>
                            <div
                                className="happy-detail-modal-card"
                                style={{ width: "460px", maxWidth: "90vw", borderRadius: "8px", padding: "20px 24px", boxSizing: "border-box" }}
                                onClick={(e) => e.stopPropagation()}
                            >
                                {/* Header */}
                                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "16px" }}>
                                    <h3 style={{ margin: 0, fontSize: "16px", fontWeight: 700, color: "#1f2937" }}>
                                        Hủy bỏ giao dịch
                                    </h3>
                                    <span
                                        className="close-btn"
                                        style={{ cursor: "pointer", fontSize: "16px", color: "#9ca3af", display: "flex", alignItems: "center", justifyContent: "center", width: "24px", height: "24px" }}
                                        onClick={() => setDenyModalOpen(false)}
                                    >
                                        ✕
                                    </span>
                                </div>

                                {/* Input Lý do hủy bỏ */}
                                <div style={{ marginBottom: "16px" }}>
                                    <label style={{ display: "block", fontSize: "14px", fontWeight: 500, color: "#374151", marginBottom: "8px" }}>
                                        Lý do hủy bỏ
                                    </label>
                                    <input
                                        type="text"
                                        value={denyReason}
                                        onChange={(e) => setDenyReason(e.target.value)}
                                        style={{
                                            width: "100%",
                                            height: "40px",
                                            padding: "0 12px",
                                            borderRadius: "6px",
                                            border: "1px solid #d9d9d9",
                                            fontSize: "14px",
                                            color: "#1f2937",
                                            outline: "none",
                                            boxSizing: "border-box"
                                        }}
                                    />
                                </div>

                                {/* Lý do gần đây */}
                                <div style={{ marginBottom: "24px" }}>
                                    <label style={{ display: "block", fontSize: "14px", fontWeight: 500, color: "#374151", marginBottom: "8px" }}>
                                        Lý do gần đây
                                    </label>
                                    <div style={{ display: "flex", flexDirection: "column", gap: "8px", maxHeight: "200px", overflowY: "auto" }}>
                                        {recentReasons.map((reasonStr, index) => {
                                            const isSelected = denyReason === reasonStr;
                                            return (
                                                <div
                                                    key={index}
                                                    onClick={() => setDenyReason(reasonStr)}
                                                    style={{
                                                        display: "flex",
                                                        justifyContent: "space-between",
                                                        alignItems: "center",
                                                        height: "40px",
                                                        padding: "0 12px",
                                                        borderRadius: "6px",
                                                        border: isSelected ? "1px solid #52c41a" : "1px solid #d9d9d9",
                                                        background: "#ffffff",
                                                        cursor: "pointer",
                                                        fontSize: "13px",
                                                        fontWeight: 500,
                                                        color: "#262626",
                                                        transition: "all 0.2s"
                                                    }}
                                                >
                                                    <span>{reasonStr}</span>
                                                    <span
                                                        onClick={(e) => deleteReason(reasonStr, e)}
                                                        style={{
                                                            padding: "4px"
                                                        }}
                                                        title="Xóa lý do này"
                                                    >
                                                        🗑
                                                    </span>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>

                                {/* Footer Buttons */}
                                <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
                                    <button
                                        type="button"
                                        onClick={() => setDenyModalOpen(false)}
                                        style={{
                                            height: "36px",
                                            padding: "0 16px",
                                            borderRadius: "6px",
                                            border: "1px solid #d9d9d9",
                                            background: "#ffffff",
                                            color: "rgba(0, 0, 0, 0.88)",
                                            fontSize: "14px",
                                            fontWeight: 400,
                                            cursor: "pointer"
                                        }}
                                    >
                                        Hủy bỏ
                                    </button>
                                    <button
                                        type="button"
                                        onClick={() => handleConfirmDeny(denyItem, denyReason)}
                                        style={{
                                            height: "36px",
                                            padding: "0 16px",
                                            borderRadius: "6px",
                                            border: "none",
                                            background: "#ef4444",
                                            color: "#ffffff",
                                            fontSize: "14px",
                                            fontWeight: 500,
                                            cursor: "pointer"
                                        }}
                                    >
                                        Xác nhận hủy bỏ giao dịch
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                </DashboardLayout>
            </ThemeProvider>
        </>
    );
}
export default Request;
